import { useQuery } from "@tanstack/react-query";
import client from "../api/sanity_client";

async function getTestimonials() {
  const data = await client.fetch(
    `*[_type == "testimonial"]{
        clientName,
        clientCompany,
        clientTitle,
        clientTestimonial
      }`
  );
  return data;
}

async function getPreview() {
  const data = await client.fetch(
  `*[_type == "project" && homepage == true] | order(_updatedAt desc) {
      _id,
      title,
      projectSummary,
      previewImage {
        asset-> {
          _id,
          url
        }
      }
    }`
  );
  return data;
}

export default function useGetHomepageInfo() {
  const { data: homepageInfo, isLoading: isLoadingHomepageInfo } = useQuery({
    queryKey: ["homepageInfo"],
    queryFn: async () => {
      const [testimonials, previews] = await Promise.all([
        getTestimonials(),
        getPreview(),
      ]);
      // const res = await fetch("/api/homepageInfo/route");
      // const data = await res.json();
      // return data;
      return { testimonials, previews,};
    },
  });
  return { homepageInfo, isLoadingHomepageInfo };
}